// extracted by mini-css-extract-plugin
export default {"horizontal":"Divider_horizontal__uYt9d","vertical":"Divider_vertical__wYLrj"};